import numeral from '@/utils/numeral.js'

// NOTE
// X en coordonnée cartésienne "standard" → longitude (est-ouest) → E (2'600'000) en CH1903+ → Y (600'000) en CH1903
// Y en coordonnée cartésienne "standard" → latitude (nord-sud) → N (1'200'000) en CH1903+ → X (200'000) en CH1903
// Affcihage CH1903+: E (longitude), N (latitude) → 2'600'000, 1'200'000
// Affichage WGS 84: latitude, longitude → 46°57'3.898" N 7°26'19.077" E (7.4386325°, 46.9510828°)
// Ne pas confondre le (X, Y) cartésien "standard" avec le (Y, X) du CH1903 qui a été changé par (E, N) en CH1903+!

// CH1903+
export function printEpsg2056 (e, n, precision = 0) {
  let format = '0,0.' + '0'.repeat(precision)
  return numeral(e).format(format) + ', ' + numeral(n).format(format)
}
